import store from '../stores';
import { defineAsyncComponent } from 'vue';

export default {
    store,
    data() {
        return {
            is_loaded: false,
        };
    },
    components: {
        // Release Notes
        'release-notes-index-component': defineAsyncComponent(() => import('./release_notes/IndexComponent.vue')),
        'release-notes-show-component': defineAsyncComponent(() => import('./release_notes/CreateEditReleaseNotesComponent.vue')),

        // Layout section
        'header-component': defineAsyncComponent(() => import('./layout/HeaderComponent.vue')),
        'sidebar-component': defineAsyncComponent(() => import('./layout/SidebarComponent.vue')),
        'content-component': defineAsyncComponent(() => import('./layout/ContentComponent.vue')),

        // App section
        'map-component': defineAsyncComponent(() => import('./app/MapComponent.vue')),

        // Alert section
        'alert-index-component': defineAsyncComponent(() => import('./alert/IndexComponent.vue')),

        // User section
        'user-create-component': defineAsyncComponent(() => import('./user/CreateComponent.vue')),
        'user-edit-component': defineAsyncComponent(() => import('./user/EditComponent.vue')),
        'user-list-component': defineAsyncComponent(() => import('./user/ListComponent.vue')),

        // Account Section
        'account-index-component': defineAsyncComponent(() => import('./account/IndexComponent.vue')),
        'account-show-component': defineAsyncComponent(() => import('./account/ShowComponent.vue')),
        'account-create-component': defineAsyncComponent(() => import('./account/CreateComponent.vue')),
        'account-edit-component': defineAsyncComponent(() => import('./account/EditComponent.vue')),
        'account-request-edit-component': defineAsyncComponent(() => import('./account/request/EditComponent.vue')),
        'account-register-component': defineAsyncComponent(() => import('./account/RegisterComponent.vue')),
        'account-subscribe-component': defineAsyncComponent(() => import('./account/SubscribeComponent.vue')),

        // Weekschedule
        'index-weekschedule-settings-component': defineAsyncComponent(() => import('./weekschedule/IndexSettingsComponent.vue')),

        // Skill section
        'index-skill-settings-component': defineAsyncComponent(() => import('./skill/IndexSettingsComponent.vue')),
        'skill-index-component': defineAsyncComponent(() => import('./skill/IndexComponent.vue')),
        'skill-archives-index-component': defineAsyncComponent(() => import('./skill/archives/ArchivesSkillIndexComponent.vue')),

        // Certificate section
        'index-certificate-settings-component': defineAsyncComponent(() => import('./certificate/IndexSettingsComponent.vue')),

        // Department section
        'department-index-component': defineAsyncComponent(() => import('./department/IndexComponent.vue')),

        // Team section
        'team-index-component': defineAsyncComponent(() => import('./team/IndexComponent.vue')),
        'team-show-component': defineAsyncComponent(() => import('./team/ShowComponent.vue')),

        // Job section
        'job-index-component': defineAsyncComponent(() => import('./job/IndexComponent.vue')),

        // Equipment section
        'equipment-show-component': defineAsyncComponent(() => import('./equipment/ShowComponent.vue')),
        'equipment-index-component': defineAsyncComponent(() => import('./equipment/IndexComponent.vue')),

        // Equipment category section
        'equipment-category-index-component': defineAsyncComponent(() => import('./equipment/category/IndexComponent.vue')),
        'equipment-category-archives-index-component': defineAsyncComponent(() => import('./equipment/category/archives/IndexComponent.vue')),

        // Task status section
        'task-status-create-component': defineAsyncComponent(() => import('./task_status/CreateComponent.vue')),
        'task-status-edit-component': defineAsyncComponent(() => import('./task_status/EditComponent.vue')),
        'task-status-index-component': defineAsyncComponent(() => import('./task_status/IndexComponent.vue')),

        // Person section
        'person-index-component': defineAsyncComponent(() => import('./person/IndexComponent.vue')),
        'person-show-component': defineAsyncComponent(() => import('./person/ShowComponent.vue')),

        // Person time sheet section
        'person-time-sheet-index-component': defineAsyncComponent(() => import('./person/time-sheet/IndexComponent.vue')),

        // Checkinatwork
        'checkinatwork': defineAsyncComponent(() => import('./checkinatwork/Checkinatwork.vue')),

        // Badge
        'badge-time-index': defineAsyncComponent(() => import('./badge/BadgeTimeIndex.vue')),

        // Company section
        'company-show-component': defineAsyncComponent(() => import('./company/ShowComponent.vue')),
        'company-index-component': defineAsyncComponent(() => import('./company/IndexComponent.vue')),

        // Contact section
        'contact-show-component': defineAsyncComponent(() => import('./contact/ShowComponent.vue')),
        'contact-index-component': defineAsyncComponent(() => import('./contact/IndexComponent.vue')),

        // Project section
        'project-show-component': defineAsyncComponent(() => import('./project/ShowComponent.vue')),
        'project-index-component': defineAsyncComponent(() => import('./project/IndexComponent.vue')),

        // Project template section
        'project-template-index-component': defineAsyncComponent(() => import('./project/project-template/IndexComponent.vue')),
        'project-template-show-component': defineAsyncComponent(() => import('./project/project-template/ShowComponent.vue')),

        // Task section
        'task-index-component': defineAsyncComponent(() => import('./task/IndexComponent.vue')),
        'task-show-component': defineAsyncComponent(() => import('./task/ShowComponent.vue')),

        // Passport section
        'passport-client-index-component': defineAsyncComponent(() => import('./passport/client/IndexComponent.vue')),
        'passport-client-edit-component': defineAsyncComponent(() => import('./passport/client/EditComponent.vue')),
        'passport-authorized-clients': defineAsyncComponent(() => import('./passport/AuthorizedClients.vue')),
        'passport-personal-access-tokens': defineAsyncComponent(() => import('./passport/client/PersonalAccessTokens.vue')),

        // Logger section
        'logger-history-component': defineAsyncComponent(() => import('./logger/HistoryComponent.vue')),
        'logger-show-component': defineAsyncComponent(() => import('./logger/ShowComponent.vue')),

        // Settings section
        'settings-component': defineAsyncComponent(() => import('./settings/SettingsComponent.vue')),
        'settings-planning-component': defineAsyncComponent(() => import('./settings/planning/PlanningSettingsComponent.vue')),
        'settings-alert-component': defineAsyncComponent(() => import('./settings/alerts/IndexComponent.vue')),
        'settings-app-component': defineAsyncComponent(() => import('./settings/app/IndexComponent.vue')),

        //checklist
        'checklist-template-index-component': defineAsyncComponent(() => import('./checklist/templates/IndexComponent.vue')),
        'checklist-template-show-component': defineAsyncComponent(() => import('./checklist/templates/ShowComponent.vue')),

        //archives
        'task-archives-index-component': defineAsyncComponent(() => import('./task/archives/ArchivesTaskIndexComponent.vue')),
        'project-archives-index-component': defineAsyncComponent(() => import('./project/archives/ArchivesProjectIndexComponent.vue')),
        'company-archives-index-component': defineAsyncComponent(() => import('./company/archives/ArchivesCompanyIndexComponent.vue')),
        'contact-archives-index-component': defineAsyncComponent(() => import('./contact/archives/ArchivesContactIndexComponent.vue')),
        'equipment-archives-index-component': defineAsyncComponent(() => import('./equipment/archives/EquipmentArchivesIndexComponent.vue')),
        'person-archives-index-component': defineAsyncComponent(() => import('./person/archives/PersonArchivesIndexComponent.vue')),
        'team-archives-index-component': defineAsyncComponent(() => import('./team/archives/ArchivesTeamIndexComponent.vue')),
        'articles-archives-index-component': defineAsyncComponent(() => import('./articles/archives/ArticlesArchivesIndexComponent.vue')),
        'articles-brands-archives-index-component': defineAsyncComponent(() => import('./articles/archives/ArticleBrandsArchivesIndexComponent.vue')),
        'articles-categories-archives-index-component': defineAsyncComponent(() => import('./articles/archives/ArticleCategoriesArchivesIndexComponent.vue')),

        //Articles
        'articles-settings-component': defineAsyncComponent(() => import('./articles/ArticlesSettingsIndexComponent.vue')),
        'articles-index-component': defineAsyncComponent(() => import('./articles/ArticlesIndexComponent.vue')),

        //task-status
        'task-status-archives-index-component': defineAsyncComponent(() => import('./task_status/TaskStatusArchivesIndexComponent.vue')),

        'articles-detail-component': defineAsyncComponent(() => import('./articles/used_articles/UsedArticlesDetailShowComponent.vue')),
        'articles-export-component': defineAsyncComponent(() => import('./articles/used_articles/ExportComponent.vue')),

        //screens
        'screens-index-component': defineAsyncComponent(() => import('./screens/ScreensIndexComponent.vue')),

        // Client Area
        // Waak
        'waak-export-billing-component': defineAsyncComponent(() => import('./client-area/waak/WaakExportBillingComponent.vue')),
        'export-work-sheets-component': defineAsyncComponent(() => import('./client-area/waak/ExportWorkSheetsComponent.vue')),
    },
    mounted() {
        jQuery(() => {
            jQuery('[data-toggle="tooltip"]').tooltip({ trigger: 'hover' });
        });
        this.is_loaded = true;
    },
};
